import { Star } from "lucide-react";

/**
 * Brand rating icons, ported from the iOS/Android assets:
 * - Filmweb: amber gradient circle-mark (pulso-ios filmweb-icon.svg)
 * - Rotten Tomatoes: tomato + leaf (Android ic_rotten_tomatoes.xml → iOS rt-icon.svg)
 * - IMDb: generic yellow star (lucide Star, #F5C518)
 */

const SIZE = 15;

export function FilmwebIcon({ size = SIZE }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 63 63" aria-hidden="true">
      <defs>
        <linearGradient id="fw-grad" x1="0.85408" y1="0.85304" x2="0.14591" y2="0.14697">
          <stop stopColor="#db9b28" offset="0" />
          <stop stopColor="#f9ba1a" offset="0.43" />
          <stop stopColor="#fed401" offset="1" />
        </linearGradient>
      </defs>
      <path
        fill="url(#fw-grad)"
        d="m31.409,0c-17.35,0 -31.409,14.102 -31.409,31.5c0,17.4 14.059,31.5 31.409,31.5c17.341,0 31.404,-14.1 31.404,-31.5c0,-17.398 -14.062,-31.5 -31.404,-31.5zm-8.573,9.165c3.467,0 6.279,2.819 6.279,6.297s-2.811,6.297 -6.279,6.297c-3.467,0 -6.278,-2.819 -6.278,-6.297c-0.001,-3.478 2.811,-6.297 6.278,-6.297zm-15.653,22.129c0,-3.478 2.811,-6.297 6.278,-6.297s6.279,2.819 6.279,6.297s-2.811,6.297 -6.279,6.297s-6.278,-2.819 -6.278,-6.297zm15.818,22.316c-3.467,0 -6.279,-2.819 -6.279,-6.297s2.811,-6.297 6.279,-6.297s6.278,2.819 6.278,6.297s-2.811,6.297 -6.278,6.297zm14.789,-18.465l-10.603,0l0,-6.605l10.603,0l0,6.605zm3.467,16.058l-2.723,-5.447c5.205,-2.623 8.785,-8.013 8.785,-14.255s-3.58,-11.632 -8.785,-14.256l2.723,-5.447c7.189,3.622 12.127,11.082 12.127,19.702c0,8.622 -4.937,16.081 -12.127,19.703z"
      />
    </svg>
  );
}

export function RottenTomatoesIcon({ size = SIZE }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" aria-hidden="true">
      <g transform="translate(1.33,0)">
        <path
          transform="translate(0,16.27)"
          fill="#FA320A"
          d="M77.0137759,27.0426556 C76.2423237,14.6741909 69.9521992,5.42041494 60.4876349,0.246970954 C60.5414108,0.548381743 60.273195,0.925145228 59.9678008,0.791701245 C53.7772614,-1.91634855 43.2753527,6.84780083 35.9365975,2.25825726 C35.9917012,3.90539419 35.6700415,11.940249 24.3515353,12.4063071 C24.0843154,12.4172614 23.9372614,12.1443983 24.1062241,11.9512033 C25.619917,10.2247303 27.1482158,5.85360996 24.9507054,3.5233195 C20.2446473,7.74041494 17.5117012,9.32746888 8.48829876,7.23319502 C2.71103734,13.2740249 -0.562655602,21.5419087 0.08,31.8413278 C1.39120332,52.86639 21.0848133,64.8846473 40.9165145,63.6471369 C60.746888,62.4106224 78.3253112,48.0677178 77.0137759,27.0426556"
        />
        <path
          fill="#00912D"
          d="M40.8717012,11.4648963 C44.946722,10.49361 56.6678838,11.3702905 60.4232365,16.3518672 C60.6486307,16.6506224 60.3312863,17.2159336 59.9678008,17.0572614 C53.7772614,14.3492116 43.2753527,23.113361 35.9365975,18.5238174 C35.9917012,20.1709544 35.6700415,28.2058091 24.3515353,28.6718672 C24.0843154,28.6828216 23.9372614,28.4099585 24.1062241,28.2167635 C25.619917,26.4902905 27.1478838,22.1191701 24.9507054,19.7888797 C19.8243983,24.3827386 17.0453112,25.8589212 5.91900415,22.8514523 C5.55485477,22.753195 5.67900415,22.1679668 6.06639004,22.020249 C8.16929461,21.2165975 12.933444,17.6965975 17.4406639,16.1450622 C18.2987552,15.8499585 19.1541909,15.6209129 19.9890456,15.4878008 C15.02639,15.0443154 12.7893776,14.3541909 9.63286307,14.8302075 C9.28697095,14.8823237 9.05195021,14.479668 9.26639004,14.2034855 C13.5193361,8.7253112 21.3540249,7.07087137 26.1878838,9.98107884 C23.2082988,6.28912863 20.8743568,3.34473029 20.8743568,3.34473029 L26.4046473,0.203485477 C26.4046473,0.203485477 28.6894606,5.30821577 30.3518672,9.02340249 C34.4657261,2.94506224 42.119834,2.38406639 45.3536929,6.69676349 C45.5455602,6.95302905 45.3450622,7.31751037 45.0247303,7.30987552 C42.3926971,7.24580913 40.9434025,9.63983402 40.833527,11.4605809 L40.8717012,11.4648963"
        />
      </g>
    </svg>
  );
}

export function ImdbIcon({ size = SIZE }: { size?: number }) {
  return <Star size={size} className="fill-[#F5C518] text-[#F5C518]" aria-hidden="true" />;
}

/** A rating chip: source icon + value. */
export function RatingValue({
  icon,
  value,
  title,
}: {
  icon: React.ReactNode;
  value: string;
  title: string;
}) {
  return (
    <span
      className="inline-flex items-center gap-1 text-[13px] font-semibold tabular-nums text-foreground/80"
      title={title}
    >
      {icon}
      {value}
    </span>
  );
}
